var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "101px",
    height: "104px",
    viewBox: "0 0 101 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Arts@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Landing-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Promo-Landing",
    transform: "translate(-1018.000000, -1828.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 1689.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12-Copy-4",
    transform: "translate(1018.000000, 139.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arts"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#00C0A2",
    points: "15.1139948 15.2887293 0.215113636 51.5663304 14.5221406 88.5019859 50.4761187 103.524429 85.9827109 87.3926941 100.876932 51.1291942 86.7330143 15.2558266 50.7650554 0.233383862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.968857,37.1374574 L61.1035591,37.1374574 L39.9884864,37.1374574 L34.1231884,37.1374574 C33.799424,37.1374574 33.5366586,37.4239542 33.5366586,37.7783899 L33.5366586,44.8286481 L33.5366586,51.8789063 L33.5366586,58.9291644 L33.5366586,65.9794226 C33.5366586,66.3338583 33.799424,66.6203551 34.1231884,66.6203551 L39.9884864,66.6203551 L61.1035591,66.6203551 L66.968857,66.6203551 C67.2926215,66.6203551 67.5553868,66.3338583 67.5553868,65.9794226 L67.5553868,58.9291644 L67.5553868,51.8789063 L67.5553868,44.8286481 L67.5553868,37.7783899 C67.5553868,37.4239542 67.2926215,37.1374574 66.968857,37.1374574 Z M40.3404043,50.7449486 L35.8045738,50.7449486 L35.8045738,46.2091182 L40.3404043,46.2091182 L40.3404043,50.7449486 Z M35.8045738,53.0128639 L40.3404043,53.0128639 L40.3404043,57.5486943 L35.8045738,57.5486943 L35.8045738,53.0128639 Z M42.6083195,58.412662 L42.6083195,51.8789063 L42.6083195,45.3451505 L42.6083195,39.4053726 L58.483726,39.4053726 L58.483726,45.3451505 L58.483726,51.8789063 L58.483726,58.412662 L58.483726,64.3524399 L42.6083195,64.3524399 L42.6083195,58.412662 Z M65.2874716,50.7449486 L60.7516412,50.7449486 L60.7516412,46.2091182 L65.2874716,46.2091182 L65.2874716,50.7449486 Z M60.7516412,53.0128639 L65.2874716,53.0128639 L65.2874716,57.5486943 L60.7516412,57.5486943 L60.7516412,53.0128639 Z M65.2874716,39.4053726 L65.2874716,43.941203 L60.7516412,43.941203 L60.7516412,39.4053726 L65.2874716,39.4053726 Z M35.8045738,39.4053726 L40.3404043,39.4053726 L40.3404043,43.941203 L35.8045738,43.941203 L35.8045738,39.4053726 Z M35.8045738,64.3524399 L35.8045738,59.8166095 L40.3404043,59.8166095 L40.3404043,64.3524399 L35.8045738,64.3524399 Z M65.2874716,64.3524399 L60.7516412,64.3524399 L60.7516412,59.8166095 L65.2874716,59.8166095 L65.2874716,64.3524399 Z M48.2781075,57.5486943 L48.2781075,46.2091182 L55.0818532,51.8789063 L48.2781075,57.5486943 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArts);
export default __webpack_public_path__ + "static/media/Arts.a5f91b84c784b61488c27c25f167e182.svg";
export { ForwardRef as ReactComponent };